import React from "react";
import PropTypes from "prop-types";

const Loading = props => {
  const { bg, blocking } = props;
  const styles = {
    background: bg
  };
  if (blocking) {
    styles.pointerEvents = "auto";
  }
  return (
    <div className="loading" style={styles}>
      <div className="loading__circles">
        <div className="loading__circle-1" />
        <div className="loading__circle-2" />
      </div>
    </div>
  );
};

Loading.propTypes = {
  bg: PropTypes.string,
  blocking: PropTypes.bool
};

Loading.defaultProps = {
  bg: null,
  blocking: true
};

export default Loading;
